import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import performRequest from "../api/request";
import { CustomErrorResponse } from "../CustomComponent/custom_error_response";
import Footer from "../Components/Footer/footer";
import LoadingPage from "../Components/layouts/loading";
import webinarDiscount from "../certificates/webinarDiscount.png";
import { Formik, Form } from "formik";
import CustomInput from "../CustomComponent/custom_input";
import { Toast } from "../CustomComponent/toast";
import FormSubmitButton from "../Components/layouts/formSubmitButton";
import { agriSubsidyInfo } from "../SchemaInfo/info";
import { agriSubsidyScheama } from "../Schemas/Agri Subsidy/agrisubsidy";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { BsBoxArrowInRight } from "react-icons/bs";

function AgriSubsidy() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [state, setState] = useState([
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ]);
  const [district, setDistrict] = useState([]);
  const [taluka, setTaluka] = useState([]);
  const [village, setVillage] = useState([]);

  const [stateNew, setStateNew] = useState();
  const [districtNew, setDistrictNew] = useState();
  const [data, setData] = useState({
    state: "",
    empStatus: "",
    farmerId: "",
  });

  const handlesubmit = (values, actions) => {
    setData(values);
    setLoading(true);
    performRequest("POST", "/subsidy/agri-subsidy/create", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Sumbited successfully!");
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  let stateFun = (e) => {
    setStateNew(e);
    performRequest("GET", `/subsidy/get-district/?state=${e}`)
      .then((res) => {
        if (res.status === 201) {
          setDistrict(res.data);
        } else {
          Toast("error", "Error while getting application!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  let districtFun = (e) => {
    setDistrictNew(e);
    performRequest(
      "GET",
      `/subsidy/get-taluka/?state=${stateNew}&district=${e}`
    )
      .then((res) => {
        if (res.status === 201) {
          setTaluka(res.data);
        } else {
          Toast("error", "Error while getting application!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  let talukaFun = (e) => {
    performRequest(
      "GET",
      `/subsidy/get-village/?state=${stateNew}&district=${districtNew}&taluka=${e}`
    )
      .then((res) => {
        if (res.status === 201) {
          setVillage(res.data);
        } else {
          Toast("error", "Error while getting application!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const ScrollToTopButton = (targetElementId) => {
    const element = document.getElementById(targetElementId);
    if (element) {
      const yOffset = -70;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <>
      <Helmet>
        <title>✅ Check Your Agri Subsidy Eligibility - Kryzen Biotech</title>
        <meta
          name="description"
          content="Get up to 85% subsidy for protected farming, hydroponics, and agri infrastructure. Apply online & check NHM, NHB, AIF eligibility instantly."
        />
        <meta
          property="og:title"
          content="Government Agri Subsidy Eligibility - Kryzen Biotech"
        />
        <meta
          property="og:description"
          content="Claim up to 85% government subsidy for your farm. NHM, NHB, AIF, PoCRA, PM-Kisan & more. Instant check – Free consultation."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://alpha.kryzen.com/agri-subsidy"
        />

        <link rel="canonical" href="https://alpha.kryzen.com/agri-subsidy" />
      </Helmet>

      <div className="page">
        <div className="page-wrapper">
          <div style={{ minHeight: "80vh" }}>
            <div className="page-body">
              <div className="container-xl">
                <div className="section text-center  py-4">
                  <div className="text-center p-3 mt-2">
                    <div>
                      <div className="">
                        <div className="">
                          <div>
                            <h1
                              className="hero-title aos-init aos-animate m-0 display-5 fw-bold"
                              style={{ fontSize: "3rem" }}
                            >
                              GET YOUR GOVERNMENT AGRI SUBSIDY <br></br>HASSLE
                              FREE!{" "}
                            </h1>
                            <h2
                              className="m-0 p-0"
                              style={{ fontsize: "100px" }}
                            >
                              Unlock Your Eligibility for NHM, NHB, AIF, and
                              More
                            </h2>
                            {/* <div className="text-center my-2">
                            <button
                              type="button"
                              className="btn btn-primary fs-3"
                              data-bs-toggle="modal"
                              data-bs-target="#check-now"
                              id="currentClose"
                            >
                              APPLY FOR SUBSIDY !
                            </button>
                          </div> */}

                            <h3>
                              Turn your vision into a sustainable farming
                              business. Build high-tech polyhouses and protected
                              farms with up to 85% government subsidy.<br></br>
                              We help you turn your land into a profitable
                              year-round farm—fully supported by schemes like
                              NHB, NHM, PoCRA, and AIF.
                            </h3>
                          </div>
                          <hr></hr>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card my-4"
                  style={{
                    background:
                      "color-mix(in srgb,rgb(255, 208, 143) 10%, transparent)",
                    color: "black",
                    border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                    padding: "1rem",
                    borderRadius: "0.25rem",
                  }}
                >
                  <div className="card-header d-flex justify-content-center ">
                    <h2 className="page-title">✅ APPLY FOR SUBSIDY</h2>
                  </div>
                  <Formik
                    initialValues={agriSubsidyInfo}
                    validationSchema={agriSubsidyScheama} // Ensure this is imported
                    onSubmit={handlesubmit} // Ensure this is defined
                    enableReinitialize
                  >
                    {(props) => (
                      <Form>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-12">
                              <div className="">
                                {/* <div className="mb-3 row">
                                  <label className="w-25 form-label text-start col-3 required">
                                    Subsidies
                                  </label>
                                  <div
                                    className="w-100 col pt-2"
                                    style={{
                                      borderRadius: "5px",
                                    }}
                                  >
                                    <div className="row ">
                                      {[
                                        "CGT-MSE",
                                        "NHB",
                                        "NHM",
                                        "PoCRA",
                                        "AIF",
                                        "PM-Kisan",
                                      ].map((subsidy) => {
                                        const isChecked =
                                          props.values.subsidy.includes(
                                            subsidy
                                          );
                                        return (
                                          <div
                                            className="form-check col-lg-4 col-md-6 col-12"
                                            key={subsidy}
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={subsidy}
                                              name="subsidy"
                                              checked={isChecked}
                                              onChange={(e) => {
                                                const selected = [
                                                  ...props.values.subsidy,
                                                ];
                                                if (e.target.checked) {
                                                  if (
                                                    !selected.includes(subsidy)
                                                  )
                                                    selected.push(subsidy);
                                                } else {
                                                  const index =
                                                    selected.indexOf(subsidy);
                                                  if (index > -1)
                                                    selected.splice(index, 1);
                                                }
                                                props.setFieldValue(
                                                  "subsidy",
                                                  selected
                                                );
                                                stateFun(selected);
                                              }}
                                              onBlur={props.handleBlur}
                                            />
                                            <label
                                              className="form-check-label text-start"
                                              htmlFor={subsidy}
                                            >
                                              {subsidy}
                                            </label>
                                          </div>
                                        );
                                      })}
                                    </div>

                                    {props.touched.subsidy &&
                                      props.errors.subsidy && (
                                        <p className="text-danger">
                                          {props.errors.subsidy}
                                        </p>
                                      )}
                                  </div>
                                </div> */}
                                {/* Name */}
                                <div className="mb-3 row">
                                  <label className="w-25 form-label text-start col-3 required">
                                    Name
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput name="name" type="text" />
                                    {props.touched.name &&
                                      props.errors.name && (
                                        <p className="text-danger">
                                          {props.errors.name}
                                        </p>
                                      )}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label text-start col-3 required">
                                    Farmer Id
                                  </label>
                                  <div className="w-100 col">
                                    <label className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="farmerId"
                                        value="yes"
                                        checked={
                                          props.values.farmerId === "yes"
                                        }
                                        onChange={props.handleChange}
                                      />
                                      <span className="form-check-label">
                                        Yes
                                      </span>
                                    </label>

                                    <label className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="farmerId"
                                        value="no"
                                        checked={props.values.farmerId === "no"}
                                        onChange={props.handleChange}
                                      />
                                      <span className="form-check-label">
                                        No
                                      </span>
                                    </label>

                                    {props.touched.farmerId &&
                                      props.errors.farmerId && (
                                        <p className="text-danger">
                                          {props.errors.farmerId}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                {/* Contact No */}
                                <div className="mb-3 row">
                                  <label className="w-25 form-label text-start col-3 required">
                                    Contact No
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput name="phoneNo" type="text" />
                                    {props.touched.phoneNo &&
                                      props.errors.phoneNo && (
                                        <p className="text-danger">
                                          {props.errors.phoneNo}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label text-start col-3 required">
                                    Employer Status
                                  </label>
                                  <div className="w-100 col">
                                    <label className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="empStatus"
                                        value="Employed"
                                        checked={
                                          props.values.empStatus === "Employed"
                                        }
                                        onChange={props.handleChange}
                                      />
                                      <span className="form-check-label">
                                        Employed
                                      </span>
                                    </label>

                                    <label className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="empStatus"
                                        value="Unemployed"
                                        checked={
                                          props.values.empStatus ===
                                          "Unemployed"
                                        }
                                        onChange={props.handleChange}
                                      />
                                      <span className="form-check-label">
                                        Unemployed
                                      </span>
                                    </label>

                                    {props.touched.empStatus &&
                                      props.errors.empStatus && (
                                        <p className="text-danger">
                                          {props.errors.empStatus}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                {/* State */}
                                <div className="mb-3 row">
                                  <label className="w-25 form-label text-start col-3 required">
                                    State
                                  </label>
                                  <div className="w-100 col">
                                    <select
                                      className="form-control"
                                      name="state"
                                      value={props.values.state}
                                      onChange={(e) => {
                                        props.setFieldValue(
                                          "state",
                                          e.target.value
                                        );
                                        stateFun(e.target.value);
                                      }}
                                    >
                                      <option value="">Select State</option>
                                      {state.map((s) => (
                                        <option key={s} value={s}>
                                          {s}
                                        </option>
                                      ))}
                                    </select>
                                    {props.touched.state &&
                                      props.errors.state && (
                                        <p className="text-danger">
                                          {props.errors.state}
                                        </p>
                                      )}
                                  </div>
                                </div>
                                {/* {stateNew === "Maharashtra" ? ( */}
                                <div>
                                  {/* District */}
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label text-start col-3 required">
                                      District
                                    </label>
                                    <div className="w-100 col">
                                      <select
                                        className="form-control"
                                        name="district"
                                        value={props.values.district}
                                        disabled={!props.values.state}
                                        onChange={(e) => {
                                          props.setFieldValue(
                                            "district",
                                            e.target.value
                                          );
                                          districtFun(e.target.value);
                                        }}
                                      >
                                        <option value="">
                                          Select District
                                        </option>
                                        {district.map((d) => (
                                          <option key={d} value={d}>
                                            {d}
                                          </option>
                                        ))}
                                      </select>
                                      {props.touched.district &&
                                        props.errors.district && (
                                          <p className="text-danger">
                                            {props.errors.district}
                                          </p>
                                        )}
                                    </div>
                                  </div>

                                  {/* Taluka */}
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label text-start col-3 required">
                                      Taluka
                                    </label>
                                    <div className="w-100 col">
                                      <select
                                        className="form-control"
                                        name="taluka"
                                        value={props.values.taluka}
                                        disabled={!props.values.district}
                                        onChange={(e) => {
                                          props.setFieldValue(
                                            "taluka",
                                            e.target.value
                                          );
                                          talukaFun(e.target.value);
                                        }}
                                      >
                                        <option value="">Select Taluka</option>
                                        {taluka.map((t) => (
                                          <option key={t} value={t}>
                                            {t}
                                          </option>
                                        ))}
                                      </select>
                                      {props.touched.taluka &&
                                        props.errors.taluka && (
                                          <p className="text-danger">
                                            {props.errors.taluka}
                                          </p>
                                        )}
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <label className="w-25 form-label text-start col-3 required">
                                      Village Name
                                    </label>
                                    <div className="w-100 col">
                                      <select
                                        className="form-control"
                                        name="vName"
                                        value={props.values.vName}
                                        disabled={!props.values.taluka}
                                        onChange={(e) =>
                                          props.setFieldValue(
                                            "vName",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="">Select Village</option>
                                        {village.map((v) => (
                                          <option key={v} value={v}>
                                            {v}
                                          </option>
                                        ))}
                                      </select>
                                      {props.touched.vName &&
                                        props.errors.vName && (
                                          <p className="text-danger">
                                            {props.errors.vName}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                {/* ) : (
                                      <div>
                                        <div className="mb-3 row">
                                          <label className="w-25 form-label text-start col-3 required">
                                            District :
                                          </label>
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="district"
                                              type="text"
                                            />
                                            {props.touched.district &&
                                              props.errors.district && (
                                                <p className="text-danger">
                                                  {props.errors.district}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                        <div className="mb-3 row">
                                          <label className="w-25 form-label text-start col-3 required">
                                            Taluka :
                                          </label>
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="taluka"
                                              type="text"
                                            />
                                            {props.touched.taluka &&
                                              props.errors.taluka && (
                                                <p className="text-danger">
                                                  {props.errors.taluka}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                        <div className="mb-3 row">
                                          <label className="w-25 form-label text-start col-3 required">
                                            Village Name :
                                          </label>
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="vName"
                                              type="text"
                                            />
                                            {props.touched.vName &&
                                              props.errors.vName && (
                                                <p className="text-danger">
                                                  {props.errors.vName}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    )} */}
                              </div>
                              <hr className="m-0 p-0"></hr>
                              <div className="text-end">
                                {/* <FormSubmitButton
                                buttonText="Submit"
                                data-bs-dismiss="modal"
                               
                              /> */}
                                <button
                                  className=" btn mx-1 mt-2 btn-green"
                                  onClick={() => ScrollToTopButton("Subsidy")}
                                >
                                  <BsBoxArrowInRight className="fs-2 me-2" />
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>

                {/* <div className="section text-center my-4 p-4 border ">
                  <div className="row row-deck">
                    <div className="col-lg-6 col-md-6 p-2">
                      <div className="card p-3">
                        <h3>
                          <span
                            className="fs-2 mb-2 fw-bold text-cyan cursor-pointer"
                            onClick={() => ScrollToTopButton("NHB-Ele")}
                          >
                            NHB (National Horticulture Board)
                          </span>
                          <br />
                          Provides 35–50% capital-linked subsidy for
                          horticulture infrastructure like cold storage,
                          pack-houses, and greenhouses.
                        </h3>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 p-2">
                      <div className="card p-3">
                        <h3>
                          <span
                            className="fs-2 mb-2 fw-bold text-cyan cursor-pointer"
                            onClick={() => ScrollToTopButton("AIF-Ele")}
                          >
                            AIF (Agriculture Infrastructure Fund)
                          </span>
                          <br />
                          Provides subsidized loans (3% interest subvention) for
                          building agricultural infrastructure like warehouses
                          and packhouses.
                        </h3>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div
                  className="section text-center my-4 p-4 border"
                  id="Subsidy"
                >
                  <div className="row row-deck">
                    {!data.state && (
                      <p className="fw-bold" style={{ fontSize: "20px" }}>
                        Submit the form to check if you are eligible or not !
                      </p>
                    )}
                    {data.state && (
                      <>
                        <p className="fw-bold" style={{ fontSize: "20px" }}>
                          You are eligible for these subsidies. Our team will
                          contact you soon !
                        </p>
                        <div className="col-lg-6 col-md-6 p-2">
                          <div
                            className="card p-3 alert alert-purple shadow-sm"
                            onMouseEnter={(e) => {
                              e.currentTarget.classList.add("shadow-lg");
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.classList.remove("shadow-lg");
                            }}
                          >
                            <h3>
                              <span
                                className="fs-2 mb-2 fw-bold text-cyan cursor-pointer"
                                onClick={() => ScrollToTopButton("NHB-Ele")}
                              >
                                NHB (National Horticulture Board)
                              </span>
                              <br />
                              Provides 35–50% capital-linked subsidy for
                              horticulture infrastructure like cold storage,
                              pack-houses, and greenhouses.
                            </h3>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 p-2">
                          <div
                            className="card p-3 alert alert-purple shadow-sm"
                            onMouseEnter={(e) => {
                              e.currentTarget.classList.add("shadow-lg");
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.classList.remove("shadow-lg");
                            }}
                          >
                            <h3>
                              <span
                                className="fs-2 mb-2 fw-bold text-cyan cursor-pointer"
                                onClick={() => ScrollToTopButton("AIF-Ele")}
                              >
                                AIF (Agriculture Infrastructure Fund)
                              </span>
                              <br />
                              Provides subsidized loans (3% interest subvention)
                              for building agricultural infrastructure like
                              warehouses and packhouses.
                            </h3>
                          </div>
                        </div>
                      </>
                    )}

                    {data.state === "Maharashtra" ? (
                      <div
                        className="col-lg-6 col-md-6 p-2 "
                        style={{ backgroundColor: "" }}
                      >
                        <div
                          className="card p-3 alert alert-warning shadow-sm"
                          onMouseEnter={(e) => {
                            e.currentTarget.classList.add("shadow-lg");
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.classList.remove("shadow-lg");
                          }}
                        >
                          <h3>
                            <span
                              className="fs-2 mb-2 fw-bold text-cyan cursor-pointer"
                              onClick={() => ScrollToTopButton("NHM-Ele")}
                            >
                              NHM (National Horticulture Mission)
                            </span>
                            <br /> Offers up to 85% subsidy for horticulture
                            development, including organic farming and protected
                            cultivation.
                          </h3>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {data.state === "Maharashtra" ? (
                      <div className="col-lg-6 col-md-6 p-2">
                        <div
                          className="card p-3 alert alert-danger shadow-sm"
                          onMouseEnter={(e) => {
                            e.currentTarget.classList.add("shadow-lg");
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.classList.remove("shadow-lg");
                          }}
                        >
                          <h3>
                            <span
                              className="fs-2 mb-2 fw-bold text-cyan cursor-pointer"
                              onClick={() => ScrollToTopButton("PoCRA-Ele")}
                            >
                              PoCRA (Project on Climate Resilient Agriculture)
                            </span>
                            <br />
                            State-based scheme giving matching grants for
                            climate-resilient farming infrastructure.
                          </h3>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {data.empStatus === "Employed" ? (
                      <div className="col-lg-6 col-md-6 p-2">
                        <div
                          className="card p-3 alert alert-success shadow-sm"
                          onMouseEnter={(e) => {
                            e.currentTarget.classList.add("shadow-lg");
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.classList.remove("shadow-lg");
                          }}
                        >
                          <h3>
                            <span
                              className="fs-2 mb-2 fw-bold text-cyan cursor-pointer"
                              onClick={() => ScrollToTopButton("CGTMSE-Ele")}
                            >
                              CGT-MSE (Credit Guarantee Fund Trust for Micro and
                              Small Enterprises)
                            </span>
                            <br />
                            Offers collateral-free credit guarantees to Micro &
                            Small Enterprises through partner banks.
                          </h3>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {data.farmerId === "yes" ? (
                      <div className="col-lg-6 col-md-6 p-2">
                        <div
                          className="card p-3 alert alert-info shadow-sm"
                          onMouseEnter={(e) => {
                            e.currentTarget.classList.add("shadow-lg");
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.classList.remove("shadow-lg");
                          }}
                        >
                          <h3>
                            <span
                              className="fs-2 mb-2 fw-bold text-cyan cursor-pointer"
                              onClick={() => ScrollToTopButton("PMKissan-Ele")}
                            >
                              PM-Kisan (Pradhan Mantri Kisan Samman Nidhi
                              Yojana)
                            </span>
                            <br />
                            CGT-MSE (Credit Guarantee Fund Trust for Micro and
                            Small Enterprises)
                          </h3>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* <div className="col-md-3 p-2">
                      <div className="card p-3">
                        <h3>
                          Under the PM-Kisan scheme, farmers receive ₹6000 per
                          year and are eligible for an interest subsidy of up to
                          3% on loans up to ₹2 crore.
                        </h3>
                      </div>
                    </div> */}
                  </div>
                </div>

                <div className="section text-center my-4 py-4">
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">
                      ❓ WHAT DO YOU GET?
                    </h2>
                    <h3 className="section-description m-0 p-0">
                      {" "}
                      You unlock secrets to create 100% TAX-FREE generational
                      wealth from farming. 💰
                    </h3>
                  </div>

                  <div className="row row-deck text-center">
                    <div className="col-md-4 my-2">
                      <div
                        className="card alert alert-warning shadow-sm"
                        onMouseEnter={(e) => {
                          e.currentTarget.classList.add("shadow-lg");
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.classList.remove("shadow-lg");
                        }}
                      >
                        <div className="card-body">
                          <img
                            width={"60%"}
                            src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/veyzVhm3.png"
                            alt=""
                          />

                          <h3 className="card-title">PROJECT DPR CREATION</h3>
                          <p className="text-secondary">
                            We draft a high-approval Detailed Project Report
                            based on your plan.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2">
                      <div
                        className="card alert alert-warning shadow-sm"
                        onMouseEnter={(e) => {
                          e.currentTarget.classList.add("shadow-lg");
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.classList.remove("shadow-lg");
                        }}
                      >
                        <div className="card-body">
                          <img
                            width={"60%"}
                            src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/hMZjdhm1.png"
                            alt=""
                          />
                          <h3 className="card-title">
                            SUBSIDY DOCUMENTATION CHECKLIST
                          </h3>
                          <p className="text-secondary">
                            Knowledge of 10 years, From basics to D learning
                            Jampacked in most curated and easy to grasp format.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2">
                      <div
                        className="card alert alert-warning shadow-sm"
                        onMouseEnter={(e) => {
                          e.currentTarget.classList.add("shadow-lg");
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.classList.remove("shadow-lg");
                        }}
                      >
                        <div className="card-body">
                          <img
                            width={"60%"}
                            src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/Gt4nyhm2.png"
                            alt=""
                          />
                          <h3 className="card-title">1-on-1 ASSISTANCE</h3>
                          <p className="text-secondary">
                            The secret KPI indices that help you build
                            foundation you need to build scalling up hydroponic
                            business.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section text-center my-6 py-6">
                  <div className="container">
                    <h2 className="display-6 fw-bold text-uppercase">
                      ✅ Wondering if You're Eligible for NHM, NHB, or AIF
                      Subsidies?
                    </h2>
                    <p className="lead my-3">
                      Answer a few quick questions and get your personalized
                      subsidy eligibility report. Our experts will guide you
                      through the next steps — 100% free, no strings attached.
                    </p>

                    {/* <button
                      className="btn btn-lg btn-primary fw-bold px-5 py-3 mt-3"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#check-now"
                      id="currentClose"
                    >
                      🔍 CHECK SUBSIDY ELIGIBILITY NOW
                    </button> */}

                    <p className="mt-3 mb-0">
                      ⏳ Takes less than 2 minutes · 📞 Instant expert follow-up
                      available
                    </p>
                  </div>
                </div>

                <div className="section text-center my-4 py-4">
                  <div className="row text-center card border-0 shadow-sm p-5 alert alert-warning">
                    <h1 className="hero-title display-6 fw-bold text-dark text-uppercase">
                      Join now and become one of India’s most empowered
                      agri-entrepreneurs!
                      <br />
                      <i className="fs-5 text-secondary">
                        Subsidy approvals don’t wait forever!
                      </i>
                    </h1>

                    <hr className="my-3" />

                    <h2 className="text-primary fw-semibold mb-4">
                      3 REASONS TO START YOUR SUBSIDY JOURNEY TODAY!
                    </h2>

                    <div className="row">
                      <div className="col-md-4 mb-2">
                        <div className="card bg-white border-0 shadow-sm p-4 m-2 h-100">
                          <h2 className="text-primary fw-bold">01.</h2>
                          <h4 className="fw-semibold">
                            Government subsidies are time-bound and
                            fund-limited.
                          </h4>
                          <p className="text-muted">
                            The sooner you apply, the better your chances of
                            getting approval and maximizing benefits.
                          </p>
                        </div>
                      </div>

                      <div className="col-md-4 mb-2">
                        <div className="card bg-white border-0 shadow-sm p-4 m-2 h-100">
                          <h2 className="text-primary fw-bold">02.</h2>
                          <h4 className="fw-semibold">
                            Subsidy-backed agri projects grow faster and
                            smarter.
                          </h4>
                          <p className="text-muted">
                            Our clients have seen 2x growth in ROI using NHM,
                            NHB, and AIF benefits.
                          </p>
                        </div>
                      </div>

                      <div className="col-md-4 mb-2">
                        <div className="card bg-white border-0 shadow-sm p-4 m-2 h-100">
                          <h2 className="text-primary fw-bold">03.</h2>
                          <h4 className="fw-semibold">
                            Agriculture income is tax-free — build wealth
                            legally.
                          </h4>
                          <p className="text-muted">
                            Get expert help to combine subsidy + farming + cash
                            flow in a scalable model.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="text-center mt-5">
                      <p className="text-dark fs-5">
                        Work with India’s Leading Agri Infrastructure Experts —
                        backed by a 160+ member team, 150+ farm projects, and
                        ₹100 Cr+ subsidy-enabled ventures.
                      </p>

                      {/* <button
                        className="btn btn-outline-primary btn-lg mt-3"
                        data-bs-toggle="modal"
                        data-bs-target="#check-now"
                      >
                        CHECK YOUR SUBSIDY ELIGIBILITY — FREE!
                      </button> */}
                    </div>
                  </div>
                </div>

                <div className="section my-5 py-4">
                  <h1 className="text-center display-6 fw-bold mb-5 text-uppercase">
                    Subsidy Schemes We Support
                  </h1>
                  <hr></hr>

                  <div className="row row-deck g-4">
                    {/* === NHM === */}
                    <div className="col-lg-6">
                      <div
                        className="card shadow-sm bg-white p-4"
                        id="NHM-Ele"
                        style={{
                          border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                        }}
                      >
                        <h2 className="text-success fw-bold">
                          🌿 1. NHM (National Horticulture Mission / MIDH)
                        </h2>
                        <p>
                          <strong>Purpose:</strong> Promote holistic
                          horticulture development through subsidies and
                          training.
                        </p>
                        <p>
                          <strong>Offered by:</strong> MIDH, Ministry of
                          Agriculture.
                        </p>
                        <ul>
                          <li>
                            Subsidies up to 85% for protected cultivation and
                            irrigation.
                          </li>
                          <li>
                            Covers shade nets, greenhouses, nurseries, and
                            orchard development.
                          </li>
                          <li>
                            Cluster-based development with training and support.
                          </li>
                        </ul>
                        <p>
                          <strong>Subsidy Type:</strong> Direct subsidy (may
                          vary by state).
                        </p>
                        <p>
                          <strong>Who benefits:</strong> Small and marginal
                          horticulture farmers.
                        </p>
                        <p>
                          <strong>When to use:</strong> To start or upgrade
                          modern horticultural farms.
                        </p>
                      </div>
                    </div>

                    {/* === NHB === */}
                    <div className="col-lg-6">
                      <div
                        className="card shadow-sm bg-white p-4"
                        id="NHB-Ele"
                        style={{
                          border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                        }}
                      >
                        <h2 className="text-purple fw-bold">
                          🍇 2. NHB (National Horticulture Board – Capital
                          Investment)
                        </h2>
                        <p>
                          <strong>Purpose:</strong> Support high-tech
                          horticulture infra like cold storage and greenhouses.
                        </p>
                        <p>
                          <strong>Offered by:</strong> NHB, Ministry of
                          Agriculture.
                        </p>
                        <ul>
                          <li>
                            35%–50% subsidy based on region (NE, hilly, tribal
                            areas).
                          </li>
                          <li>
                            Supports polyhouses, cold storage, ripening
                            chambers, etc.
                          </li>
                          <li>Cost norms vary by project type and region.</li>
                        </ul>
                        <p>
                          <strong>Subsidy Type:</strong> Credit-linked capital
                          subsidy.
                        </p>
                        <p>
                          <strong>Who benefits:</strong> Farmers, co-ops,
                          companies with bank-linked projects.
                        </p>
                        <p>
                          <strong>When to use:</strong> For large-scale
                          protected cultivation infrastructure.
                        </p>
                      </div>
                    </div>

                    {/* === AIF === */}
                    <div className="col-lg-6">
                      <div
                        className="card shadow-sm bg-white p-4"
                        id="AIF-Ele"
                        style={{
                          border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                        }}
                      >
                        <h2 className="text-info fw-bold">
                          🏗️ 3. AIF (Agriculture Infrastructure Fund)
                        </h2>
                        <p>
                          <strong>Purpose:</strong> Boost farm-gate infra and
                          supply chains.
                        </p>
                        <p>
                          <strong>Offered by:</strong> Ministry of Agriculture &
                          Farmers Welfare.
                        </p>
                        <ul>
                          <li>
                            Loans up to ₹2 Cr with 3% interest subvention (7
                            years).
                          </li>
                          <li>Credit guarantee under CGTMSE.</li>
                          <li>
                            Eligible for packhouses, cold storage, dryers, etc.
                          </li>
                        </ul>
                        <p>
                          <strong>Subsidy Type:</strong> Interest subvention +
                          guarantee fee support.
                        </p>
                        <p>
                          <strong>Who benefits:</strong> Farmers, FPOs,
                          startups, cooperatives.
                        </p>
                        <p>
                          <strong>When to use:</strong> For post-harvest infra
                          with bank finance.
                        </p>
                      </div>
                    </div>

                    {/* === PoCRA === */}
                    <div className="col-lg-6">
                      <div
                        className="card shadow-sm bg-white p-4"
                        id="PoCRA-Ele"
                        style={{
                          border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                        }}
                      >
                        <h2 className="text-warning fw-bold">
                          🏡 4. PoCRA (Climate Resilient Agriculture –
                          Maharashtra)
                        </h2>
                        <p>
                          <strong>Purpose:</strong> Promote climate-smart
                          farming in drought-prone areas.
                        </p>
                        <p>
                          <strong>Offered by:</strong> Govt. of Maharashtra with
                          World Bank support.
                        </p>
                        <ul>
                          <li>
                            Up to 75% grant for greenhouses, ponds, drip
                            irrigation.
                          </li>
                          <li>
                            Village-level microplanning and DBT-based fund
                            release.
                          </li>
                          <li>
                            Supports watershed and soil health development.
                          </li>
                        </ul>
                        <p>
                          <strong>Subsidy Type:</strong> Matching grant via DBT.
                        </p>
                        <p>
                          <strong>Who benefits:</strong> Eligible tribal/small
                          farmers in Maharashtra.
                        </p>
                        <p>
                          <strong>When to use:</strong> To build water and
                          climate infrastructure on-farm.
                        </p>
                      </div>
                    </div>

                    {/* === CGTMSE === */}
                    <div className="col-lg-6">
                      <div
                        className="card shadow-sm bg-white p-4"
                        id="CGTMSE-Ele"
                        style={{
                          border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                        }}
                      >
                        <h2 className="text-teal fw-bold">
                          🌱 5. CGTMSE (Credit Guarantee for Micro & Small
                          Enterprises)
                        </h2>
                        <p>
                          <strong>Purpose:</strong> Provide collateral-free
                          loans to small businesses.
                        </p>
                        <p>
                          <strong>Offered by:</strong> SIDBI and Ministry of
                          MSME.
                        </p>
                        <ul>
                          <li>Credit up to ₹2 crore without collateral.</li>
                          <li>Guarantee cover: 75%–85% of loan.</li>
                          <li>For working capital & term loans.</li>
                        </ul>
                        <p>
                          <strong>Subsidy Type:</strong> Indirect (Govt.
                          guarantees to banks).
                        </p>
                        <p>
                          <strong>Who benefits:</strong> Small businesses and
                          startups with no collateral.
                        </p>
                        <p>
                          <strong>When to use:</strong> When starting or scaling
                          without asset backup.
                        </p>
                      </div>
                    </div>

                    {/* === PM-Kisan === */}
                    <div className="col-lg-6">
                      <div
                        className="card shadow-sm bg-white p-4"
                        id="PMKissan-Ele"
                        style={{
                          border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                        }}
                      >
                        <h2 className="text-danger fw-bold">
                          🌾 6. PM-Kisan (Pradhan Mantri Kisan Samman Nidhi)
                        </h2>
                        <p>
                          <strong>Purpose:</strong> Provide income support to
                          landholding farmers.
                        </p>
                        <p>
                          <strong>Offered by:</strong> Ministry of Agriculture,
                          Govt. of India.
                        </p>
                        <ul>
                          <li>₹6,000/year via 3 DBT installments.</li>
                          <li>Sent directly to Aadhaar-linked accounts.</li>
                          <li>For seasonal and input expenses.</li>
                        </ul>
                        <p>
                          <strong>Subsidy Type:</strong> Direct cash transfer.
                        </p>
                        <p>
                          <strong>Who benefits:</strong> Small/marginal
                          landholding farmers.
                        </p>
                        <p>
                          <strong>When to use:</strong> For seasonal input or
                          financial support.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section text-center my-4 py-4">
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">
                      RIGHT SYSTEMS, RIGHT STRATEGIES, RIGHT PARTNERS
                    </h2>
                    <h3 className="section-description my-0 p-0">
                      {" "}
                      Backed by industry leaders, Designed for greartness!
                    </h3>
                  </div>

                  <div className="row">
                    <div className="col-md-3 col-sm-6">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/xkEwFhm41.png"
                        alt="Horty Daily"
                      />
                    </div>

                    <div className="col-md-3 col-sm-6">
                      <img
                        width="60%"
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/Okdrahm48.jpg"
                        alt="Divya Marathi"
                      />
                    </div>

                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/Foizfhm45.png"
                        alt="NBT"
                      />
                    </div>
                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/gYvl6hm43.png"
                        alt="Hindustan Times"
                      />
                    </div>

                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/XIAtDhm47.png"
                        alt="Dainik Bhaskar"
                      />
                    </div>

                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/wZd3Phm44.png"
                        alt="Financial Times"
                      />
                    </div>
                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/Pvm5Vhm49.png"
                        alt="Loksatta"
                      />
                    </div>

                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/EhnJohm42.png"
                        alt="Times of India"
                      />
                    </div>
                  </div>
                  <div className="mt-2 text-center d-flex justify-content-center">
                    <div className="col-md-6">
                      <img
                        width={"90%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/X2gZhbackedbyindustryleaders.png"
                        alt="Backend By"
                      />
                    </div>
                  </div>
                </div>

                <div className="section text-center my-4 py-4">
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">
                      TESTIMONIALS
                    </h2>
                    <h3 className="section-description my-0 p-0">
                      Hear Directly From Farmers and Agripreneurs Like You
                    </h3>
                  </div>

                  <div className="row">
                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “I had no idea I was eligible for NHB subsidy. The
                            Kryzen team handled everything—from DPR to
                            documentation. Got ₹42 lakh support for my cold
                            storage!”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3>Rakesh Yadav, Indore, MP</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “Their AIF assistance helped us secure low-interest
                            funding and get subsidy approval within 4 months.
                            Excellent support from start to finish.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3>Anita Jha, Ranchi, Jharkhand</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “As a first-time agripreneur, I was overwhelmed by
                            government paperwork. Kryzen simplified it all and
                            helped me get NHM support for a hydroponic setup.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3>Farhan Siddiqui, Lucknow, UP</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “The Kryzen subsidy team went above and beyond. They
                            reviewed my business plan and helped align it
                            perfectly with NHB norms. I’m grateful for their
                            guidance.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3>Sarika Deshmukh, Nashik, Maharashtra</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “From subsidy documentation to direct department
                            follow-up, Kryzen handled it all. Today, my mushroom
                            unit runs with AIF backing.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3>Bipin Raj, Ernakulam, Kerala</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “No false promises. Just real guidance. I recovered
                            60% of my investment through NHM subsidy thanks to
                            their DPR team.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3>Komal Rathi, Jaipur, Rajasthan</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section my-4 py-4">
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">FAQ's</h2>
                    <h3 className="section-description my-0 p-0">
                      Common questions about our Agri Subsidy Support
                    </h3>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div className="accordion" id="accordion-default">
                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-1-default"
                              aria-expanded="false"
                            >
                              What is the Agri Subsidy Support Program?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-1-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div className="accordion-body">
                              It’s a complete assistance program to help farmers
                              and agripreneurs apply and receive subsidies under
                              schemes like NHM, NHB, AIF, and more — with expert
                              help in DPR, documentation, and filing.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-2-default"
                              aria-expanded="false"
                            >
                              Who can apply for government agriculture
                              subsidies?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-2-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div className="accordion-body">
                              Farmers, FPOs, agri startups, landowners, women
                              entrepreneurs, and even urban professionals
                              setting up agri infra projects are eligible under
                              various schemes.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-3-default"
                              aria-expanded="false"
                            >
                              Do I need to own land to be eligible?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-3-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div className="accordion-body">
                              Not necessarily. Some schemes allow leased land or
                              shared land ownership. Our team verifies your
                              eligibility based on your documentation and goals.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-4-default"
                              aria-expanded="false"
                            >
                              What kind of projects are eligible for subsidy?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-4-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div className="accordion-body">
                              Projects like hydroponics, polyhouse farming, cold
                              storage, packhouses, grading units, and
                              agri-processing units are eligible depending on
                              the scheme.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-5-default"
                              aria-expanded="false"
                            >
                              How much subsidy can I get?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-5-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div className="accordion-body">
                              Depending on the scheme, you may be eligible for
                              40%–75% subsidy on your project cost. NHB and NHM
                              subsidies can go up to ₹50–75 lakhs or more.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-6-default"
                              aria-expanded="false"
                            >
                              Will you help with the paperwork and DPR?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-6-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div className="accordion-body">
                              Yes. Our team provides full documentation support
                              — including subsidy-aligned DPRs, financial
                              projections, quotations, layout plans, and
                              follow-up.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="accordion" id="accordion-second">
                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-11-default"
                              aria-expanded="false"
                            >
                              How long does the subsidy approval take?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-11-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div className="accordion-body">
                              Depending on the scheme and documentation
                              readiness, it can take between 3 to 6 months. We
                              help speed up the process by maintaining all
                              required compliance.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-22-default"
                              aria-expanded="false"
                            >
                              Do I need a company to apply?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-22-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div className="accordion-body">
                              Not always. Individual farmers, partnerships,
                              FPOs, or private limited companies — all are
                              eligible depending on the scheme. We guide you
                              accordingly.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-33-default"
                              aria-expanded="false"
                            >
                              Can you help me even if I already started the
                              project?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-33-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div className="accordion-body">
                              Yes, in many cases, post-project applications are
                              accepted if you have valid bills, photos, and
                              layouts. Let our team assess your case and guide
                              you accordingly.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-44-default"
                              aria-expanded="false"
                            >
                              How do I get started with Kryzen’s subsidy
                              assistance?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-44-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div className="accordion-body">
                              Simply click “Check Eligibility” on this page or
                              call us at +91-9870-424-425. Our team will guide
                              you through the entire subsidy journey.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-55-default"
                              aria-expanded="false"
                            >
                              Are there any hidden charges?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-55-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div className="accordion-body">
                              No. We offer clear pricing with milestone-based
                              service charges. No commission on subsidy or loan
                              received. All terms are shared before onboarding.
                            </div>
                          </div>
                        </div>

                        <div className="accordion-item">
                          <div className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-66-default"
                              aria-expanded="false"
                            >
                              Need help? How can I contact you?
                              <div className="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-66-default"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div className="accordion-body">
                              You can reach out to us anytime at{" "}
                              <b>support@kryzen.com</b> or call/WhatsApp us on{" "}
                              <b>+91-9870-424-425</b>.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="section text-center card my-4 py-4"
                  style={{
                    background:
                      "color-mix(in srgb,rgb(255, 208, 143) 10%, transparent)",
                    color: "black",
                    border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                    padding: "1rem",
                    borderRadius: "0.25rem",
                  }}
                >
                  <div className="row my-4">
                    <h2 className="hero-title display-6 fw-bold">
                      WE ARE ON A MISSION TO HELP 1 MILLION FARMERS &
                      AGRIPRENEURS ACCESS GOVERNMENT SUBSIDIES.
                    </h2>
                    <h3 className="section-description my-0 p-0">
                      AND TRANSFORM INDIA INTO A GLOBAL AGRICULTURE POWERHOUSE!
                    </h3>
                  </div>

                  <hr className="my-4" />

                  <h2 className="hero-title display-6 fw-bold">
                    Be a Part of India's Subsidy Success Story 🚜
                  </h2>

                  <h3>
                    <s>Consultation Value: ₹35,999/-</s>
                  </h3>
                  <h2>
                    <s>Market Price: ₹45,999/-</s>
                  </h2>

                  {/* <div className="text-center my-3">
                    <button
                      className="btn btn-success fw-bold px-4 py-2"
                      data-bs-toggle="modal"
                      data-bs-target="#check-now"
                    >
                      ✅ CHECK YOUR ELIGIBILITY!
                    </button>
                  </div> */}

                  <h3 className="fw-semibold">No hidden fees, no agents.</h3>
                  <p>
                    Just genuine guidance, real documentation, and expert
                    support to claim your subsidy.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="toast fade"
            id="toast-simple"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-bs-autohide="false"
          >
            <div className="toast-body">
              {`⏰ Another Spot Gone ⏰`} <br />{" "}
              {/* {`${userData?.randomUser}, from ${userData?.randomCity}. Enrolled`} */}
            </div>
          </div>
          <Footer />
        </div>
      </div>

      <style>{`
        .toast {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #333;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  opacity: 0;
  transform: translateY(100%);
  transition: all 1s ease;
  z-index: 9999;
}

.toast.show {
  opacity: 1;
  transform: translateY(0);
}

        `}</style>
    </>
  );
}

export default AgriSubsidy;
